import { useCallback, useRef, useState } from 'react';
import { useVariable } from './useVariable';
import { refContainsTarget } from '../helpers/refs';
import { getEventTargets } from '../helpers/events-target';
export const useHoverEvents = (onOver, onOut, initialRef, initialExcludedRef, needChangeState = true, needCheckState = true) => {
  const nativeRef = useRef(null);
  const ref = initialRef || nativeRef;
  const nativeExcludedRef = useRef(null);
  const excludedRef = initialExcludedRef || nativeExcludedRef;
  const hovered = useRef(false);
  const handleOver = useVariable(onOver);
  const handleOut = useVariable(onOut);
  const [isHovered, setIsHovered] = useState(false);
  const onMouseOver = useCallback((e, force = false) => {
    if (hovered.current && needCheckState && !force) {
      return;
    }
    handleOver.current?.(e);
    hovered.current = true;
    if (needChangeState) {
      setIsHovered(true);
    }
  }, [needChangeState, needCheckState]);
  const onMouseOut = useCallback((e, force = false) => {
    const {
      relatedTarget
    } = getEventTargets(e);
    const containsTarget = refContainsTarget(ref, relatedTarget) || refContainsTarget(excludedRef, relatedTarget);
    if ((!hovered.current && needCheckState || containsTarget) && !force) {
      return;
    }
    hovered.current = false;
    if (needChangeState) {
      setIsHovered(false);
    }
    handleOut.current?.(e);
  }, [needChangeState, needCheckState]);
  return {
    ref,
    refExcluded: excludedRef,
    onMouseOver,
    onMouseOut,
    isHovered
  };
};